import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Es legal hacer esto yo misma?',
    a: 'Sí, es un derecho federal bajo la Ley FCRA. No necesitas ser abogado para disputar tu propio crédito.'
  }, {
    q: '¿Necesito saber inglés fluido?',
    a: 'No. Las cartas ya están redactadas en el inglés técnico que los burós entienden. Tú solo llenas los espacios en blanco.'
  }, {
    q: '¿Cuánto tiempo toma ver resultados?',
    a: 'Por ley, los burós tienen 30 días para responder. La mayoría de nuestras usuarias ven cambios significativos en los primeros 45 a 60 días.'
  }, {
    q: '¿Funciona si tengo ITIN?',
    a: 'Tener un número de ITIN no impide tener un historial de crédito; este método funciona para cualquier reporte generado en USA.'
  }];
  return <section className="py-24 bg-brand-cream relative" data-id="element-23">
      <div className="container mx-auto px-6" data-id="element-24">
        <FadeIn data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-dark mb-16" data-id="element-26">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-27">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-28">
              <div className={`bg-white rounded-xl border transition-all duration-300 overflow-hidden ${openIndex === index ? 'border-brand-gold shadow-md' : 'border-gray-200 hover:border-brand-pink'}`} data-id="element-29">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-30">
                  <span className="font-bold text-brand-dark text-lg pr-4" data-id="element-31">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-brand-rose transform transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-32" />
                </button>

                <div className={`transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-33">
                  <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-50 pt-4" data-id="element-34">
                    {faq.a}
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}